import React, { useState, useEffect, useContext } from "react";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import BackButton from "../Buttons/BackButton";
import { useForm } from "react-hook-form";
import { AppContext } from "../../contexts/AppContext";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";
import { useNavigate } from "react-router-dom";
import NameChange from "../NameChange/index.js";
import GenderChange from "../GenderChange/index.js";
import Check from "../../assets/images/Check.svg";
import FieldError from "../FieldError/index.jsx";

const ReviewPassport = ({ handleNext, handleBack }) => {
  const { handleSubmit } = useForm();
  const navigate = useNavigate();

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { day: "2-digit", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-NZ", options); // Example: 27 April 1948
  };

  const { appState, userFlows } = useContext(AppContext);

  const passportData = appState.requestPayload.applicant;
  const eventData = appState.requestPayload.eventTypeSearch[0] || {};
  const changedName = appState.requestPayload.eventTypeSearch[1] || null;

  // console.log("ReviewPassport Data:", passportData, eventData, changedName);

  const [genderLabel, setGenderLabel] = useState("");
  const [addressCountryLabel, setAddressCountryLabel] = useState("");

  useEffect(() => {
    // Load passport data from localStorage if not already in state

    getLabelFromId("GenderReference", eventData?.genderId).then(
      (genderLabel) => {
        setGenderLabel(genderLabel);
      }
    );

    getCountryNameById(passportData.countryOfBirthId).then((countryName) => {
      setAddressCountryLabel(countryName);
    });
  }, [eventData?.genderId, passportData?.countryOfBirthId]);

  const onSubmit = () => {
    console.log("Confirmed Data:", passportData);
    console.log(userFlows);
    if (userFlows.showPartnerStore) {
      navigate("/app/photo-id");
      return;
    }
    if (!userFlows.showLiveness) {
      navigate("/app/photo-id");
      return;
    }
    handleNext();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          <h1 className="intro-title-mi" lang="mi-NZ">
            Arotakehia ō taipitopito
          </h1>
          <hr />
          <h1 className="intro-title">Review your details</h1>

          <div style={{ marginTop: 64 }}>
            <FieldError
              info={
                "We'll verify your identity using these details. If they're incorrect, contact the <a class='cancel-link' href='https://www.passports.govt.nz/contactus/in-new-zealand'> Passport Office.</a>"
              }
              error={null}
            />

            {appState?.requestPayload?.supportingInformation
              ?.nameChangeSourceCode && <NameChange />}
            {appState?.requestPayload?.supportingInformation
              ?.genderSourceCode && <GenderChange />}
          </div>

          <div className="step-container">
            <h2 className="step-title mb-2">
              Your New Zealand passport details
            </h2>
            <div className="step-container-nospace">
              <div className="step-container-box">
                <p className="label">Given name(s)</p>
                <p className="value">
                  {passportData?.namesKnownAs?.[0]?.givenNames || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Surname or family name</p>
                <p className="value">
                  {passportData?.namesKnownAs?.[0]?.familyName || "-"}
                </p>
              </div>
              {eventData?.documentNumber && (
                <div className="step-container-box">
                  <p className="label">Passport number</p>
                  <p className="value">{eventData?.documentNumber}</p>
                </div>
              )}

              <div className="step-container-box">
                <p className="label">Date of birth</p>
                <p className="value">
                  {formatDate(passportData?.dateOfBirth) || "-"}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Place of birth (town/city)</p>
                <p className="value">
                  {passportData?.placeOfBirth?.trim()
                    ? passportData.placeOfBirth
                    : "Unknown"}
                  </p>
              </div>
              <div className="step-container-box">
                <p className="label">Country of birth</p>
                <p className="value">{addressCountryLabel}</p>
              </div>
              <div className="step-container-box">
                <p className="label">Gender</p>
                <p className="value">{genderLabel}</p>
              </div>
              {/* Add more fields if available in your localStorage data */}
            </div>
          </div>
        </div>

        <div className="step-button-container">
          <SubmitButton text={"Confirm"} type="submit" Icon={Check} />
          <BackButton text={"Back"} onClick={handleBack} />
        </div>
      </form>
    </>
  );
};

export default ReviewPassport;
